import { gql } from '@apollo/client';

import { startOfWeek, endOfWeek, getUnixTime } from 'date-fns';

import POST_FIELDS from './fragments/post';

const GET_CALENDAR_WEEK_QUERY = gql`
  query GetCalendarWeek(
    $startDate: Int!
    $endDate: Int!
    $seed: Int!
    $channelIds: [ID!]
    $timezone: String!
    $use24HourTime: Boolean!
    $includeDrafts: Boolean
  ) {
    calendar(
      input: {
        startDate: $startDate
        endDate: $endDate
        timezone: $timezone
        use24HourTime: $use24HourTime
        channelIds: $channelIds
        _seed: $seed
        intervalSize: oneHour
        includeDrafts: $includeDrafts
      }
    ) {
      ... on Calendar {
        posts {
          ...PostFields
        }
        days {
          startTimestamp
          dayName
          dayOfMonth
          monthName
          campaigns {
            id
            name
          }
          intervals {
            label
            startTimestamp
            posts {
              id
            }
          }
        }
      }
    }
  }
  ${POST_FIELDS}
`;

export function mocks(currentDate, channelIds, use24HourTime, seed = 10) {
  const startDate = startOfWeek(currentDate);
  const endDate = endOfWeek(currentDate);

  return [
    {
      request: {
        query: GET_CALENDAR_WEEK_QUERY,
        variables: {
          startDate: getUnixTime(startDate),
          endDate: getUnixTime(endDate),
          seed,
          channelIds,
          timezone: 'Europe/Madrid',
          use24HourTime,
          includeDrafts: true,
        },
      },
      result: {
        data: {
          calendar: {
            posts: [
              {
                id: '63cec2dcc95273aab90c9384',
                type: 'post',
                text: 'Good girl adorable borking beaglelino super chub long bois waggy wags beaglelino super chub borking many woofs boof doggo. Good girl borking woofa sdfsd sdf  sdf er ruff corgo many pats long bois waggy wags doge corgo many pats super chub bork shoob snoo. https://buff.ly/3iKMMty',
                status: 'sent',
                error: null,
                isReminder: false,
                isCustomScheduled: true,
                isPinned: true,
                formattedTime: '18:24',
                isRetweet: false,
                dueAt: 1674494698,
                title: null,
                createdBy: '62a76434183e2c5e9a63cbf3',
                needsApproval: false,
                sourceUrl: null,
                isBlueprint: null,
                updateType: null,
                threadCount: null,
                channelData: null,
                statistics: null,
                geoLocation: null,
                channel: {
                  id: '62b024d6d477f60c13b4574e',
                  service: 'facebook',
                  avatar:
                    'https://scontent-mad1-1.xx.fbcdn.net/v/t39.30808-1/305487853_599202705235288_3583510889680924600_n.jpg?stp=c0.0.50.50a_cp0_dst-jpg_p50x50&_nc_cat=110&ccb=1-7&_nc_sid=dbb9e7&_nc_ohc=36wDUA1V9M8AX-h8D-S&_nc_ht=scontent-mad1-1.xx&edm=AGaHXAAEAAAA&oh=00_AfC2XLn_bhSeBfW5WbDB1NwuHS7t9wBsAMu12Km9wYgO6g&oe=63A07B32',
                  username: 'Global Pet Page',
                  serverUrl: null,
                  locationData: null,
                },
                subprofile: null,
                attachments: null,
                media: null,
                campaign: null,
              },
            ],
            days: [
              {
                startTimestamp: 1674342000,
                dayName: 'Sunday',
                dayOfMonth: 22,
                monthName: 'January',
                campaigns: null,
                intervals: [
                  {
                    label: '0:00',
                    startTimestamp: 1674342000,
                    posts: [],
                  },
                  {
                    label: '1:00',
                    startTimestamp: 1674345600,
                    posts: [],
                  },
                  {
                    label: '2:00',
                    startTimestamp: 1674349200,
                    posts: [],
                  },
                  {
                    label: '3:00',
                    startTimestamp: 1674352800,
                    posts: [],
                  },
                  {
                    label: '4:00',
                    startTimestamp: 1674356400,
                    posts: [],
                  },
                  {
                    label: '5:00',
                    startTimestamp: 1674360000,
                    posts: [],
                  },
                  {
                    label: '6:00',
                    startTimestamp: 1674363600,
                    posts: [],
                  },
                  {
                    label: '7:00',
                    startTimestamp: 1674367200,
                    posts: [],
                  },
                  {
                    label: '8:00',
                    startTimestamp: 1674370800,
                    posts: [],
                  },
                  {
                    label: '9:00',
                    startTimestamp: 1674374400,
                    posts: [],
                  },
                  {
                    label: '10:00',
                    startTimestamp: 1674378000,
                    posts: [],
                  },
                  {
                    label: '11:00',
                    startTimestamp: 1674381600,
                    posts: [],
                  },
                  {
                    label: '12:00',
                    startTimestamp: 1674385200,
                    posts: [],
                  },
                  {
                    label: '13:00',
                    startTimestamp: 1674388800,
                    posts: [],
                  },
                  {
                    label: '14:00',
                    startTimestamp: 1674392400,
                    posts: [],
                  },
                  {
                    label: '15:00',
                    startTimestamp: 1674396000,
                    posts: [],
                  },
                  {
                    label: '16:00',
                    startTimestamp: 1674399600,
                    posts: [],
                  },
                  {
                    label: '17:00',
                    startTimestamp: 1674403200,
                    posts: [],
                  },
                  {
                    label: '18:00',
                    startTimestamp: 1674406800,
                    posts: [],
                  },
                  {
                    label: '19:00',
                    startTimestamp: 1674410400,
                    posts: [],
                  },
                  {
                    label: '20:00',
                    startTimestamp: 1674414000,
                    posts: [],
                  },
                  {
                    label: '21:00',
                    startTimestamp: 1674417600,
                    posts: [],
                  },
                  {
                    label: '22:00',
                    startTimestamp: 1674421200,
                    posts: [],
                  },
                  {
                    label: '23:00',
                    startTimestamp: 1674424800,
                    posts: [],
                  },
                ],
              },
              {
                startTimestamp: 1674428400,
                dayName: 'Monday',
                dayOfMonth: 23,
                monthName: 'January',
                campaigns: null,
                intervals: [
                  {
                    label: '0:00',
                    startTimestamp: 1674428400,
                    posts: [],
                  },
                  {
                    label: '1:00',
                    startTimestamp: 1674432000,
                    posts: [],
                  },
                  {
                    label: '2:00',
                    startTimestamp: 1674435600,
                    posts: [],
                  },
                  {
                    label: '3:00',
                    startTimestamp: 1674439200,
                    posts: [],
                  },
                  {
                    label: '4:00',
                    startTimestamp: 1674442800,
                    posts: [],
                  },
                  {
                    label: '5:00',
                    startTimestamp: 1674446400,
                    posts: [],
                  },
                  {
                    label: '6:00',
                    startTimestamp: 1674450000,
                    posts: [],
                  },
                  {
                    label: '7:00',
                    startTimestamp: 1674453600,
                    posts: [],
                  },
                  {
                    label: '8:00',
                    startTimestamp: 1674457200,
                    posts: [],
                  },
                  {
                    label: '9:00',
                    startTimestamp: 1674460800,
                    posts: [],
                  },
                  {
                    label: '10:00',
                    startTimestamp: 1674464400,
                    posts: [],
                  },
                  {
                    label: '11:00',
                    startTimestamp: 1674468000,
                    posts: [],
                  },
                  {
                    label: '12:00',
                    startTimestamp: 1674471600,
                    posts: [],
                  },
                  {
                    label: '13:00',
                    startTimestamp: 1674475200,
                    posts: [],
                  },
                  {
                    label: '14:00',
                    startTimestamp: 1674478800,
                    posts: [],
                  },
                  {
                    label: '15:00',
                    startTimestamp: 1674482400,
                    posts: [],
                  },
                  {
                    label: '16:00',
                    startTimestamp: 1674486000,
                    posts: [],
                  },
                  {
                    label: '17:00',
                    startTimestamp: 1674489600,
                    posts: [],
                  },
                  {
                    label: '18:00',
                    startTimestamp: 1674493200,
                    posts: [
                      {
                        id: '63cec2dcc95273aab90c9384',
                      },
                    ],
                  },
                  {
                    label: '19:00',
                    startTimestamp: 1674496800,
                    posts: [],
                  },
                  {
                    label: '20:00',
                    startTimestamp: 1674500400,
                    posts: [],
                  },
                  {
                    label: '21:00',
                    startTimestamp: 1674504000,
                    posts: [],
                  },
                  {
                    label: '22:00',
                    startTimestamp: 1674507600,
                    posts: [],
                  },
                  {
                    label: '23:00',
                    startTimestamp: 1674511200,
                    posts: [],
                  },
                ],
              },
              {
                startTimestamp: 1674514800,
                dayName: 'Tuesday',
                dayOfMonth: 24,
                monthName: 'January',
                campaigns: null,
                intervals: [
                  {
                    label: '0:00',
                    startTimestamp: 1674514800,
                    posts: [],
                  },
                  {
                    label: '1:00',
                    startTimestamp: 1674518400,
                    posts: [],
                  },
                  {
                    label: '2:00',
                    startTimestamp: 1674522000,
                    posts: [],
                  },
                  {
                    label: '3:00',
                    startTimestamp: 1674525600,
                    posts: [],
                  },
                  {
                    label: '4:00',
                    startTimestamp: 1674529200,
                    posts: [],
                  },
                  {
                    label: '5:00',
                    startTimestamp: 1674532800,
                    posts: [],
                  },
                  {
                    label: '6:00',
                    startTimestamp: 1674536400,
                    posts: [],
                  },
                  {
                    label: '7:00',
                    startTimestamp: 1674540000,
                    posts: [],
                  },
                  {
                    label: '8:00',
                    startTimestamp: 1674543600,
                    posts: [],
                  },
                  {
                    label: '9:00',
                    startTimestamp: 1674547200,
                    posts: [],
                  },
                  {
                    label: '10:00',
                    startTimestamp: 1674550800,
                    posts: [],
                  },
                  {
                    label: '11:00',
                    startTimestamp: 1674554400,
                    posts: [],
                  },
                  {
                    label: '12:00',
                    startTimestamp: 1674558000,
                    posts: [],
                  },
                  {
                    label: '13:00',
                    startTimestamp: 1674561600,
                    posts: [],
                  },
                  {
                    label: '14:00',
                    startTimestamp: 1674565200,
                    posts: [],
                  },
                  {
                    label: '15:00',
                    startTimestamp: 1674568800,
                    posts: [],
                  },
                  {
                    label: '16:00',
                    startTimestamp: 1674572400,
                    posts: [],
                  },
                  {
                    label: '17:00',
                    startTimestamp: 1674576000,
                    posts: [],
                  },
                  {
                    label: '18:00',
                    startTimestamp: 1674579600,
                    posts: [],
                  },
                  {
                    label: '19:00',
                    startTimestamp: 1674583200,
                    posts: [],
                  },
                  {
                    label: '20:00',
                    startTimestamp: 1674586800,
                    posts: [],
                  },
                  {
                    label: '21:00',
                    startTimestamp: 1674590400,
                    posts: [],
                  },
                  {
                    label: '22:00',
                    startTimestamp: 1674594000,
                    posts: [],
                  },
                  {
                    label: '23:00',
                    startTimestamp: 1674597600,
                    posts: [],
                  },
                ],
              },
              {
                startTimestamp: 1674601200,
                dayName: 'Wednesday',
                dayOfMonth: 25,
                monthName: 'January',
                campaigns: null,
                intervals: [
                  {
                    label: '0:00',
                    startTimestamp: 1674601200,
                    posts: [],
                  },
                  {
                    label: '1:00',
                    startTimestamp: 1674604800,
                    posts: [],
                  },
                  {
                    label: '2:00',
                    startTimestamp: 1674608400,
                    posts: [],
                  },
                  {
                    label: '3:00',
                    startTimestamp: 1674612000,
                    posts: [],
                  },
                  {
                    label: '4:00',
                    startTimestamp: 1674615600,
                    posts: [],
                  },
                  {
                    label: '5:00',
                    startTimestamp: 1674619200,
                    posts: [],
                  },
                  {
                    label: '6:00',
                    startTimestamp: 1674622800,
                    posts: [],
                  },
                  {
                    label: '7:00',
                    startTimestamp: 1674626400,
                    posts: [],
                  },
                  {
                    label: '8:00',
                    startTimestamp: 1674630000,
                    posts: [],
                  },
                  {
                    label: '9:00',
                    startTimestamp: 1674633600,
                    posts: [],
                  },
                  {
                    label: '10:00',
                    startTimestamp: 1674637200,
                    posts: [],
                  },
                  {
                    label: '11:00',
                    startTimestamp: 1674640800,
                    posts: [],
                  },
                  {
                    label: '12:00',
                    startTimestamp: 1674644400,
                    posts: [],
                  },
                  {
                    label: '13:00',
                    startTimestamp: 1674648000,
                    posts: [],
                  },
                  {
                    label: '14:00',
                    startTimestamp: 1674651600,
                    posts: [],
                  },
                  {
                    label: '15:00',
                    startTimestamp: 1674655200,
                    posts: [],
                  },
                  {
                    label: '16:00',
                    startTimestamp: 1674658800,
                    posts: [],
                  },
                  {
                    label: '17:00',
                    startTimestamp: 1674662400,
                    posts: [],
                  },
                  {
                    label: '18:00',
                    startTimestamp: 1674666000,
                    posts: [],
                  },
                  {
                    label: '19:00',
                    startTimestamp: 1674669600,
                    posts: [],
                  },
                  {
                    label: '20:00',
                    startTimestamp: 1674673200,
                    posts: [],
                  },
                  {
                    label: '21:00',
                    startTimestamp: 1674676800,
                    posts: [],
                  },
                  {
                    label: '22:00',
                    startTimestamp: 1674680400,
                    posts: [],
                  },
                  {
                    label: '23:00',
                    startTimestamp: 1674684000,
                    posts: [],
                  },
                ],
              },
              {
                startTimestamp: 1674687600,
                dayName: 'Thursday',
                dayOfMonth: 26,
                monthName: 'January',
                campaigns: null,
                intervals: [
                  {
                    label: '0:00',
                    startTimestamp: 1674687600,
                    posts: [],
                  },
                  {
                    label: '1:00',
                    startTimestamp: 1674691200,
                    posts: [],
                  },
                  {
                    label: '2:00',
                    startTimestamp: 1674694800,
                    posts: [],
                  },
                  {
                    label: '3:00',
                    startTimestamp: 1674698400,
                    posts: [],
                  },
                  {
                    label: '4:00',
                    startTimestamp: 1674702000,
                    posts: [],
                  },
                  {
                    label: '5:00',
                    startTimestamp: 1674705600,
                    posts: [],
                  },
                  {
                    label: '6:00',
                    startTimestamp: 1674709200,
                    posts: [],
                  },
                  {
                    label: '7:00',
                    startTimestamp: 1674712800,
                    posts: [],
                  },
                  {
                    label: '8:00',
                    startTimestamp: 1674716400,
                    posts: [],
                  },
                  {
                    label: '9:00',
                    startTimestamp: 1674720000,
                    posts: [],
                  },
                  {
                    label: '10:00',
                    startTimestamp: 1674723600,
                    posts: [],
                  },
                  {
                    label: '11:00',
                    startTimestamp: 1674727200,
                    posts: [],
                  },
                  {
                    label: '12:00',
                    startTimestamp: 1674730800,
                    posts: [],
                  },
                  {
                    label: '13:00',
                    startTimestamp: 1674734400,
                    posts: [],
                  },
                  {
                    label: '14:00',
                    startTimestamp: 1674738000,
                    posts: [],
                  },
                  {
                    label: '15:00',
                    startTimestamp: 1674741600,
                    posts: [],
                  },
                  {
                    label: '16:00',
                    startTimestamp: 1674745200,
                    posts: [],
                  },
                  {
                    label: '17:00',
                    startTimestamp: 1674748800,
                    posts: [],
                  },
                  {
                    label: '18:00',
                    startTimestamp: 1674752400,
                    posts: [],
                  },
                  {
                    label: '19:00',
                    startTimestamp: 1674756000,
                    posts: [],
                  },
                  {
                    label: '20:00',
                    startTimestamp: 1674759600,
                    posts: [],
                  },
                  {
                    label: '21:00',
                    startTimestamp: 1674763200,
                    posts: [],
                  },
                  {
                    label: '22:00',
                    startTimestamp: 1674766800,
                    posts: [],
                  },
                  {
                    label: '23:00',
                    startTimestamp: 1674770400,
                    posts: [],
                  },
                ],
              },
              {
                startTimestamp: 1674774000,
                dayName: 'Friday',
                dayOfMonth: 27,
                monthName: 'January',
                campaigns: null,
                intervals: [
                  {
                    label: '0:00',
                    startTimestamp: 1674774000,
                    posts: [],
                  },
                  {
                    label: '1:00',
                    startTimestamp: 1674777600,
                    posts: [],
                  },
                  {
                    label: '2:00',
                    startTimestamp: 1674781200,
                    posts: [],
                  },
                  {
                    label: '3:00',
                    startTimestamp: 1674784800,
                    posts: [],
                  },
                  {
                    label: '4:00',
                    startTimestamp: 1674788400,
                    posts: [],
                  },
                  {
                    label: '5:00',
                    startTimestamp: 1674792000,
                    posts: [],
                  },
                  {
                    label: '6:00',
                    startTimestamp: 1674795600,
                    posts: [],
                  },
                  {
                    label: '7:00',
                    startTimestamp: 1674799200,
                    posts: [],
                  },
                  {
                    label: '8:00',
                    startTimestamp: 1674802800,
                    posts: [],
                  },
                  {
                    label: '9:00',
                    startTimestamp: 1674806400,
                    posts: [],
                  },
                  {
                    label: '10:00',
                    startTimestamp: 1674810000,
                    posts: [],
                  },
                  {
                    label: '11:00',
                    startTimestamp: 1674813600,
                    posts: [],
                  },
                  {
                    label: '12:00',
                    startTimestamp: 1674817200,
                    posts: [],
                  },
                  {
                    label: '13:00',
                    startTimestamp: 1674820800,
                    posts: [],
                  },
                  {
                    label: '14:00',
                    startTimestamp: 1674824400,
                    posts: [],
                  },
                  {
                    label: '15:00',
                    startTimestamp: 1674828000,
                    posts: [],
                  },
                  {
                    label: '16:00',
                    startTimestamp: 1674831600,
                    posts: [],
                  },
                  {
                    label: '17:00',
                    startTimestamp: 1674835200,
                    posts: [],
                  },
                  {
                    label: '18:00',
                    startTimestamp: 1674838800,
                    posts: [],
                  },
                  {
                    label: '19:00',
                    startTimestamp: 1674842400,
                    posts: [],
                  },
                  {
                    label: '20:00',
                    startTimestamp: 1674846000,
                    posts: [],
                  },
                  {
                    label: '21:00',
                    startTimestamp: 1674849600,
                    posts: [],
                  },
                  {
                    label: '22:00',
                    startTimestamp: 1674853200,
                    posts: [],
                  },
                  {
                    label: '23:00',
                    startTimestamp: 1674856800,
                    posts: [],
                  },
                ],
              },
              {
                startTimestamp: 1674860400,
                dayName: 'Saturday',
                dayOfMonth: 28,
                monthName: 'January',
                campaigns: null,
                intervals: [
                  {
                    label: '0:00',
                    startTimestamp: 1674860400,
                    posts: [],
                  },
                  {
                    label: '1:00',
                    startTimestamp: 1674864000,
                    posts: [],
                  },
                  {
                    label: '2:00',
                    startTimestamp: 1674867600,
                    posts: [],
                  },
                  {
                    label: '3:00',
                    startTimestamp: 1674871200,
                    posts: [],
                  },
                  {
                    label: '4:00',
                    startTimestamp: 1674874800,
                    posts: [],
                  },
                  {
                    label: '5:00',
                    startTimestamp: 1674878400,
                    posts: [],
                  },
                  {
                    label: '6:00',
                    startTimestamp: 1674882000,
                    posts: [],
                  },
                  {
                    label: '7:00',
                    startTimestamp: 1674885600,
                    posts: [],
                  },
                  {
                    label: '8:00',
                    startTimestamp: 1674889200,
                    posts: [],
                  },
                  {
                    label: '9:00',
                    startTimestamp: 1674892800,
                    posts: [],
                  },
                  {
                    label: '10:00',
                    startTimestamp: 1674896400,
                    posts: [],
                  },
                  {
                    label: '11:00',
                    startTimestamp: 1674900000,
                    posts: [],
                  },
                  {
                    label: '12:00',
                    startTimestamp: 1674903600,
                    posts: [],
                  },
                  {
                    label: '13:00',
                    startTimestamp: 1674907200,
                    posts: [],
                  },
                  {
                    label: '14:00',
                    startTimestamp: 1674910800,
                    posts: [],
                  },
                  {
                    label: '15:00',
                    startTimestamp: 1674914400,
                    posts: [],
                  },
                  {
                    label: '16:00',
                    startTimestamp: 1674918000,
                    posts: [],
                  },
                  {
                    label: '17:00',
                    startTimestamp: 1674921600,
                    posts: [],
                  },
                  {
                    label: '18:00',
                    startTimestamp: 1674925200,
                    posts: [],
                  },
                  {
                    label: '19:00',
                    startTimestamp: 1674928800,
                    posts: [],
                  },
                  {
                    label: '20:00',
                    startTimestamp: 1674932400,
                    posts: [],
                  },
                  {
                    label: '21:00',
                    startTimestamp: 1674936000,
                    posts: [],
                  },
                  {
                    label: '22:00',
                    startTimestamp: 1674939600,
                    posts: [],
                  },
                  {
                    label: '23:00',
                    startTimestamp: 1674943200,
                    posts: [],
                  },
                ],
              },
            ],
          },
        },
      },
    },
  ];
}

export default GET_CALENDAR_WEEK_QUERY;
